<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title" style="display: flex;align-items: center;">ព័ត៌មានអំពីការកក់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-40">
				<table style="border-width: 0px; line-height: 32px;">
					<tr>
						<td style="width: 150px">លេខកូដកក់</td>
						<td style="width: 40px">៖</td>
						<td>{{book.code}}</td>
					</tr>
					<tr>
						<td>ចំនួនកញ្ចប់</td>
						<td>៖</td>
						<td>{{book.total_package}} កញ្ចប់</td>
					</tr>
					<tr>
						<td>ថ្ងៃទៅទទួល</td>
						<td>៖</td>
						<td>{{book.pickup_date}}</td>
					</tr>
					<tr>
						<td>ចំណាំ</td>
						<td>៖</td>
						<td>{{book.description}}</td>
					</tr>
					<tr>
						<td>ស្ថានភាព</td>
						<td>៖</td>
						<td>
							<span class="error" v-if="book.status == 'NODRIVER'">{{ config.getStatus(book.status) }}</span>
							<span class="neutral" v-if="book.status == 'PENDING'">{{ config.getStatus(book.status) }}</span>
							<span class="green" v-if="book.status == 'COMPLETED'">{{ config.getStatus(book.status) }}</span>
							<span class="return" v-if="book.status == 'CANCELED'">{{ config.getStatus(book.status) }}</span>
						</td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-40">
				<table style="border-width: 0px; line-height: 32px;">
					<tr>
						<td style="width: 150px">ឈ្មោះអតិថិជន</td>
						<td style="width:40px">៖</td>
						<td>{{book.client_name}} ({{book.client_phone}})</td>
					</tr>
					<tr>
						<td>ចំណាំអតិថិជន</td>
						<td>៖</td>
						<td>{{book.client_note}}</td>
					</tr>
					<tr>
						<td>អ្នកដឹកជញ្ជូន</td>
						<td>៖</td>
						<td>{{book.driver_name || "មិនមាន"}}</td>
					</tr>
					<tr>
						<td>លេខទូរស័ព្ទ</td>
						<td>៖</td>
						<td>{{book.driver_phone || "មិនមាន"}}</td>
					</tr>
					<tr>
						<td>ថ្ងៃដាក់ស្នើ</td>
						<td>៖</td>
						<td>{{config.datelify(book.created_date) || "មិនមាន"}}</td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20" style="display: flex; flex-direction: column; align-items: center;">
				<span style="margin-bottom: 8px">QR កូដ Booking</span>
				<qr-code :text="'BKG-'+book.hash_id" :size="300" style="width: 100%; max-width: 150px;"></qr-code>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">កំណត់ចំណាំផ្ទៃក្នុងរបស់ការកក់</h3>
				<p v-if="String(book.package_note).length > 0">{{book.note}}</p>
				<p v-else>មិនមាន</p>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">កែប្រែកំណត់ចំណាំរបស់ការកក់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25">
				<md-field>
					<label>ជ្រើសរើសចំណាំការកក់ផ្ទៃក្នុង</label>
					<md-select placeholder="ជ្រើសរើសចំណាំការកក់ផ្ទៃក្នុង" v-model="note">
						<md-option value="មិនមាន">មិនមាន</md-option>
						<md-option value="ចាំថ្ងៃស្អែក">ចាំថ្ងៃស្អែក</md-option>
						<md-option value="យកថ្ងៃស្អែក">យកថ្ងៃស្អែក</md-option>
						<md-option value="ប្តូរទីតាំង">ប្តូរទីតាំង</md-option>
						<md-option value="អីវ៉ាន់ខុស">អីវ៉ាន់ខុស</md-option>
					</md-select>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-70 md-size-25">
				<md-field>
					<label>កំណត់ចំណាំថ្មី</label>
					<md-input type="text" v-model="note"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-30  md-size-20">
				<md-button class="md-raised md-success" @click="updateNote()">រក្សាទុក</md-button>
			</div>

			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-danger" @click="cancel(book.hash_id)"
					v-if="book.status != 'COMPLETED' && book.status != 'CANCELED'">បោះបង់ការកក់</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="cancelDialog" md-title="តើអ្នកពិតជាចង់បោះបង់ការកក់នេះមែនឬ?"
			md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="cancel" />
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		created() {
			this.getBooking();
		},
		data() {
			return {
				loaded: false,
				cancelDialog: false,
				cancelID: "",
				book: {},
				note: ""
			}
		},
		methods: {
			getBooking(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/book/get/" + this.$route.params.hash_id).then(data => {
					this.book = data.body.data
					this.loaded = true
				});
			},
			cancel(id = "") {
				if (id == "" && String(this.cancelID).length > 0) {
					this.$http.post(this.config.api + "/admin/book/cancel", {
						hash_id: this.book.hash_id
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "ការកក់បានបោះបង់ដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getBooking();
							this.onCancel();
						}
					})
				} else {
					this.cancelID = id;
					this.cancelDialog = true;
				}

			},
			updateNote() {
				this.$http.post(this.config.api + "/admin/book/note", {
						hash_id: this.book.hash_id,
						note: this.note
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "ការកក់ត្រូវបានកែប្រែកំណត់ចំណាំដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getBooking();
							this.onCancel();
						}
					})
			},
			onCancel() {
				this.cancelDialog = false;
				this.cancelID = "";
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Booking/Detail.vue